import { RouteObject } from "react-router-dom";
import MainChat from "../pages/chat";

let routes: RouteObject[] = [
   {
        path: "/chat",
        children: [
            {
                index: true,
                element: <MainChat />,
            },
            {
                path: ":id",
                element: <MainChat />,
            },
        ],
    },
]
export default routes